import React, { useEffect } from "react";
import StartArrows from "../../../assets/svgs/StartArrows";
import styles from "./styles.module.css";
import AnimatedNudge from "../AnimatedNudge";
import tripleSixIcon from "../../../assets/triple-six-dice-icon.svg";
import hexagonShape from "../../../assets/hexagon-shape-icon.svg";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { GAMEPLAY_ANIMATION_IMAGES } from "../../../assets";
import { useTranslation } from "react-i18next";
import { getTripleSixAnimation } from "../../../store/selectors/ludoboardSelectors";
import { playStartSoundOfGame } from "../../../classes/voiceovers/GameSoundManager";
import { SOUND_KEYS } from "../constant";
import { playSound } from "../../../classes/sound";

function _playSkipSound() {
  playSound(SOUND_KEYS.SKIP)
}

function TripleSixAnimation() {
  const { t } = useTranslation();
  const tripleSixAnimation = useSelector(getTripleSixAnimation);

  useEffect(() => {
    if (tripleSixAnimation) {
      setTimeout(_playSkipSound, 500);
    }
  }, [tripleSixAnimation]);

  if (!tripleSixAnimation) {
    return null;
  }

  return (
    <AnimatedNudge>
      <div 
        className={clsx(styles.wrapper, "hexagonShapeWrapper")}
        style={{ 
          backgroundImage: `url(${GAMEPLAY_ANIMATION_IMAGES.hexagonShape})`, 
          width: getWidth(110), 
          height: getWidth(72)
        }}
      >
        <img
          src={tripleSixIcon}
          className={clsx(styles.thumbsUp)}
          alt="Thumbs Up"
          width={getWidth(74)}
          height="auto"
        />
        <div className={clsx(styles.text, "hexagonShapeText fontSizeSm12 fontWeight900 textUppercase fontColorDanger2 flex alignItemCenter justifyContentCenter relative")}>{t("turnSkipped")}</div>
      </div>
    </AnimatedNudge>
  );
}

export default TripleSixAnimation;
